import React, { useEffect, useState, useCallback } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { useApplicationCommon } from "../../utils/ApplicationCommon";
import { Link } from "react-router-dom";

const GNBPURE02001S = () => {

    const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
    const toggleDropdown = (e) => {
        e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
        setIsOpen(!isOpen); // 상태 토글
    };

	const [isOpen2, setIsOpen2] = useState(false);

	const openModal = () => setIsOpen2(true);
	const closeModal = () => setIsOpen2(false);

  return (
	<CommonLayout>
      <CommonMenu />
		<>
		  <div id="contents" className="container">
			<div className="sub-title bg-type02">
			  <h2>제품소개</h2>
			</div>

			<div className="location_wrap">
			  <ul className="depth1">
				<li>
				  <Link to="/">home</Link>
				</li>
				<li>
                    <a href="#none" onClick={toggleDropdown}>
                        온라인대출<span></span>
                    </a>
				    <ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
                        <li>
                            <Link to="/GNBPURE02001S">온라인대출</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02002S">스탁론</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02003S">NPL</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02004S">기관연계시스템</Link>
                        </li>
                        <li>
                            <Link to="/GNBPURE02000S">통합솔루션</Link>
                        </li>
                    </ul>
				</li>
			  </ul>
			</div>

			<div id="cont" className="cont">
			  <div className="inner">
				<h3>온라인대출</h3>

				<article>
					<p className="subtitle">여신종합시스템</p>
					<p className="txt-wrap">여신종합시스템은 중소형 금융기관용 차세대뱅킹시스템의 각 Component Module을 가장 효과적으로 조립한 시스템으로서 인터넷대출, 여신고객평가시스템 등을 중심으로구성되어 있습니다. 특히 대부분의 여신전문기관이 단편적으로 적용해 오던 전산시스템을 Total시스템으로 확장, 모든 업무를 망라함으로써 체계적인 운영 및 관리가 가능합니다.</p>
					<img src="../../asset/img/subB/img_credit.png" alt="여신시스템" className="img-sub pc"/>
					<img src="../../asset/img/subB/img_credit_mo.png" alt="여신시스템" className="mo"/>
				</article>
				
				<article>
					<p className="subtitle">시스템연계</p>
					<img src="../../asset/img/subB/img_int.png" alt="인터넷 대출시스템" className="img-sub pc"/>
					<img src="../../asset/img/subB/img_int.png" alt="인터넷 대출시스템" className="mt10 mo"/>
				</article>
	
				
				<article>
					<p className="subtitle">CSS 심사</p>
					<p className="txt-wrap">Pure Solution Css는 고객이 신청한 내역을 기준으로 대외기관 평가정보와 사내 거래고객인 경우 사내 고객 평가정보를 통하여 대출여부는물론 채권금액 및 금리를 제시하기 위한 시스템으로 3단계에 걸쳐 심사를 수행합니다.</p>
					{/* <div className="modal-zoom mo">

						<button type="button" className="btn-sm btn-info" onClick={openModal}>이미지 확대하기</button>

							{isOpen2 && (
								<div className="modal-overlay ">
								<div className="modal-content">
									<img src="../../asset/pure/img/subC/img_product_01_4.png" alt="여신전문기관용 CSS 심사 과정 이미지"/>
									<button onClick={closeModal}>닫기</button>
								</div>
								</div>
							)}
					</div> */}
					<img src="../../asset/pure/img/subC/img_product_01_4.png" alt="여신전문기관용 CSS 심사 과정 이미지"/>
				</article>
			  </div>
			</div>
		  </div>
		  <CommonFooter />
		</>
	</CommonLayout>
  );
};

export default GNBPURE02001S;
